import React from "react";
import Footer from "../layouts/Footer";
import AffiliateBanner from "../bannners/AffliliateBanner";
import Header from "../layouts/Header";

function Affiliate({ sliderGuide }) {
  return (
    <div className="et-boc">
      <Header />
      <div id="et-main-area">
        <div id="main-content">
          <AffiliateBanner sliderGuide={sliderGuide} />
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default Affiliate;
